import { Alert, AlertColor, Snackbar } from '@mui/material'

export type FlashProps = {
  open: boolean
  message?: string
  severity?: AlertColor
  autoHideDuration?: number
  onClose: () => void
}

export const Flash = ({
  open,
  message,
  severity = 'error',
  autoHideDuration = 5000,
  onClose,
}: FlashProps) => {
  if (!open || !message) return null

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    >
      <Alert severity={severity} variant="filled" onClose={onClose}>
        {message}
      </Alert>
    </Snackbar>
  )
}
